export default {
  container: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    background: '#f9f9f9'
  }
}
